export default __webpack_public_path__ + "static/media/logout.2322a24d.png";